export default {"src":"/_next/static/media/ongoing-management.49d6da19.svg","height":1008,"width":1008,"blurWidth":0,"blurHeight":0};